import { useUnit } from 'effector-react';
import $$auth from 'models/auth';
import { $pathname } from 'models/location';
import { Link } from 'react-router-dom';

import { Button } from 'components/StyledTemplates/StyledTemplates';

import useResources from 'hooks/useResources';

const $isTrustFundingQuestionnaire = $pathname.map((pathname) => pathname.split('/').slice(1)?.[1] === 'TRUST_FUND');

const QuestionnaireMenu = () => {
    const { t } = useResources();

    const isTrustFundingQuestionnaire = useUnit($isTrustFundingQuestionnaire);

    const systemRoles = useUnit($$auth.$systemRoles);
    const isAdvisor = systemRoles.includes('advisor');

    return (
        <div className="d-flex flex-column align-items-center gap-2 mt-2">
            <Link to="/dashboard" className="w-100">
                <Button className="w-100">
                    {isTrustFundingQuestionnaire ? t('header.trustFunding') : t('navHeader.dashboard')}
                </Button>
            </Link>
            {isAdvisor && (
                <Link to="/advisor/dashboard" className="w-100">
                    <Button className="w-100">{t('navHeader.backToAdvisorDashboard')}</Button>
                </Link>
            )}
        </div>
    );
};

export default QuestionnaireMenu;
